module.exports = __webpack_public_path__ + "img/ic_worker.87ee392b.svg";